export class DeleteRequest {
    public id: number;
    public programId: number;
    public programName: string;
    public name: string;
    public reason: number;
    public date: Date;
    public phone: string;
    public email: string;
    public comments: string;
    public captchaCode: string;
}


// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/requests/delete-request.ts